export const COUNTRY_CODES = {
  India: "in", "United States": "us", Canada: "ca", "United Kingdom": "gb", France: "fr", Germany: "de", Italy: "it",
  Spain: "es", Netherlands: "nl", Sweden: "se", Russia: "ru", Turkey: "tr", "United Arab Emirates": "ae",
  "Saudi Arabia": "sa", Egypt: "eg", Nigeria: "ng", Kenya: "ke", "South Africa": "za", Brazil: "br", Mexico: "mx",
  Japan: "jp", China: "cn", "South Korea": "kr", Philippines: "ph", Indonesia: "id", Australia: "au",
  Pakistan: "pk", Bangladesh: "bd", "Sri Lanka": "lk", Nepal: "np", Singapore: "sg", Malaysia: "my", Thailand: "th",
  Vietnam: "vn", "New Zealand": "nz", Ireland: "ie", Portugal: "pt", Poland: "pl", Ukraine: "ua", Greece: "gr",
  Argentina: "ar", Colombia: "co", Chile: "cl", Peru: "pe", Ghana: "gh", Ethiopia: "et", Morocco: "ma", Qatar: "qa",
  Kuwait: "kw", Oman: "om", Israel: "il", Iran: "ir", Switzerland: "ch", Belgium: "be", Norway: "no", Denmark: "dk",
};
export const ALL_COUNTRIES = Object.keys(COUNTRY_CODES).sort();
export const slugify = (c) => c.toLowerCase().replace(/ /g, "-");
export const fromSlug = (s) => ALL_COUNTRIES.find((c) => slugify(c) === s);
export const flagUrl = (c, w = 80) => (COUNTRY_CODES[c] ? `https://flagcdn.com/w${w}/${COUNTRY_CODES[c]}.png` : null);
